// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"08b52a81","465":"ff47a4b4","627":"9ddfb1f0","819":"6b9898a1","906":"d1989222"}[chunkId] + ".chunk.css";
};